import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import GelOrientationImage from './img/gel-top.svg';
import {Image} from '@learningblocks/shared-components/lib/Image';

export function GelOrientation(props) {

  const {t} = useTranslation();

  const getLanes = () => {

    let lanes = [];

    for(var lane in props.lanes){
      lanes.push({
        lane: lane.replace('lane', 'Lane '),
        contents: (props.lanes[lane].solutionAlias !== "")?props.lanes[lane].solutionAlias:"[Empty]"
      })
    }

    if(props.orientation !== 360){
      lanes.reverse();
    }

    return (
      <>
        <div style={{
          display: "flex",
          flexDirection: "row",
          width: "180px",
          padding: "0 "+(props.orientation == 360?"290px":"93px"),
          top: "209px",
          position: "relative",
          transform: "rotate(90deg)"
        }}>
          {lanes.map((lane, index) => (
            <div style={{marginLeft: "4px", marginRight: "4px", width: "100%", display: "flex", flexDirection: "column"}}>
              <div style={{
                width: "100%",
                height: "12px",
                borderLeft: "2px solid #7EA2B4",
                borderRight: "2px solid #7EA2B4",
                borderTop: "2px solid #5688a0",
                borderBottom: "2px solid #5688a0",
                boxSizing: "border-box",
                background: (lane.contents !== "[Empty]")?"#00AEEF":"#396477"
              }}></div>
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <div className={props.className}>
      <div className={`${props.className}_lanes`}>
        {getLanes()}
      </div>
      <div className={`${props.className}_image`}>
        <Image
          src={GelOrientationImage}
          alt={t('ControlsPanel.string')}
          className={`${props.className}_image_main`}
        />
      </div>
    </div>
  );
}

GelOrientation.propTypes = {
  /**
   * ClassName to set on component
   */
  className: PropTypes.string,
  /**
   * Current rpm value set
   */
  rpmValue: PropTypes.number,
  /**
   * Current Runtime set
   */
  timeValue: PropTypes.instanceOf(Date),
  /**
   * Time left for centrifuge to run to completion
   */
  timeLeft: PropTypes.instanceOf(Date),
  /**
   * Function to set RPM value
   */
  setRPM: PropTypes.func,
  /**
   * Function to set Run Time
   */
  setTimeValue: PropTypes.func,
  /**
   * Function to invoke when to  run the Centrifuge
   */
  runCentrifuge: PropTypes.func,
};

GelOrientation.defaultProps = {};
